import { Modal } from "bootstrap";

/**
 * Shows a Bootstrap confirmation modal and runs async action if confirmed
 */
export const confirmAndRun = ({
  title,
  message,
  confirmText = "Kyllä, jatka",
  cancelText = "Peru",
  action,
}) => {
  return new Promise((resolve, reject) => {
    // Create modal container
    const modalEl = document.createElement("div");
    modalEl.className = "modal fade";
    modalEl.tabIndex = -1;

    modalEl.innerHTML = `
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">${title}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
          </div>
          <div class="modal-body">
            <p>${message}</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">
              ${cancelText}
            </button>
            <button type="button" class="btn btn-primary confirm-btn">
              ${confirmText}
            </button>
          </div>
        </div>
      </div>
    `;

    document.body.appendChild(modalEl);

    const modal = new Modal(modalEl, {
      backdrop: "static",
      keyboard: false,
    });

    const cleanup = () => {
      modal.dispose();
      modalEl.remove();
    };

    modalEl.querySelector(".confirm-btn").addEventListener("click", async () => {
      try {
        await action();
        cleanup();
        resolve(true);
      } catch (err) {
        console.error("Confirmed action failed:", err);
        cleanup();
        reject(err);
      }
    });

    modalEl.addEventListener("hidden.bs.modal", () => {
      cleanup();
      resolve(false);
    });

    modal.show();
  });
};
